import { useEffect, useCallback } from 'react'

export default function Lightbox({ src, alt, title, onClose }) {
  const close = useCallback(() => onClose(), [onClose])

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') close() }
    const prev = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    document.addEventListener('keydown', onKey)
    return () => {
      document.removeEventListener('keydown', onKey)
      document.body.style.overflow = prev
    }
  }, [close])

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label={`Agrandir : ${alt}`}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/85 p-4 md:p-10 cursor-zoom-out"
      onClick={close}
    >
      <button
        onClick={close}
        aria-label="Fermer"
        className="absolute top-4 right-5 text-white/60 hover:text-white text-4xl leading-none transition-colors select-none"
      >
        ×
      </button>

      <figure
        className="flex flex-col items-center gap-3 max-w-5xl w-full cursor-default"
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={src}
          alt={alt}
          title={title}
          className="max-h-[85vh] w-full object-contain rounded-xl shadow-2xl"
          decoding="async"
        />
        {title && (
          <figcaption className="text-white/55 text-sm text-center">{title}</figcaption>
        )}
      </figure>
    </div>
  )
}
